import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-footer',
  templateUrl: './offline-footer.component.html',
  styleUrls: ['./offline-footer.component.scss']
})
export class OfflineFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
